/* __next_internal_client_entry_do_not_use__ SDUIFilterStoreProvider auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import cloneDeep from "lodash/cloneDeep";
import { useEffect } from "react";
import * as React from "react";
import { FilterContext } from "@faire/retailer/components/Filters/FilterContext";
import { FilterState, useCreateFilterStore } from "@faire/retailer/components/Filters/FilterStore";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { useSDUIFilterablePaginatedSectionState } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";
export var SDUIFilterStoreProvider = function(param) {
    var filterablePaginatedSection = param.filterablePaginatedSection, children = param.children;
    var _useSDUIFilterablePaginatedSectionState = useSDUIFilterablePaginatedSectionState(), setFilterKeys = _useSDUIFilterablePaginatedSectionState.setFilterKeys, clearOneIndexedPageNumber = _useSDUIFilterablePaginatedSectionState.clearOneIndexedPageNumber;
    var _useFilterablePaginatedSectionQuery = useFilterablePaginatedSectionQuery(filterablePaginatedSection), isFilterLoading = _useFilterablePaginatedSectionQuery.isFilterLoading, filtersResponse = _useFilterablePaginatedSectionQuery.filtersResponse;
    var onFilterSelected = function(state) {
        var filterKeys = getSelectedFilterKeys(state.filterSections);
        setFilterKeys(function() {
            return filterKeys;
        });
        clearOneIndexedPageNumber();
    };
    var filterStore = useCreateFilterStore(FilterState.build(), onFilterSelected);
    useEffect(function() {
        if ((filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.filter_sections) && !isFilterLoading) {
            filterStore.setState(function(currentState) {
                return _object_spread_props(_object_spread({}, currentState), {
                    filterSections: cloneDeep(filtersResponse.filter_sections),
                    isNewFilterSelected: false
                });
            });
        }
    }, [
        isFilterLoading,
        filtersResponse,
        filterStore
    ]);
    return /*#__PURE__*/ _jsx(FilterContext.Provider, {
        value: filterStore,
        children: children
    });
};
